export enum Status {
   Open = 0,
   Pendding = 1,
   SoftClosed = 2,
   ReOpened = 3,
   Closed = 4,
   Approved = 5,
   WorkInPogress = 6,
   Rejected = 7,
   All = 8,
};
